import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import { Trans } from "@lingui/react/macro";
import { Router } from "preact-router";
import Markdown from 'preact-markdown';

import { useHeadlessComponent } from "../../../utils/component-converter";
import { CMSText as AwrabetCMSText } from "../../awrabet/desktop-pages/content.jsx";

export function ContentBody() {
	return <div class="flex max-w-7xl mx-auto min-h-[inherit]">
		<nav class="hidden md:block max-w-xs w-full bg-harif-900 text-slate-50 shrink-0">
			<Accordion open={true}>
				<MenuButton><Trans>Main</Trans></MenuButton>
				<div>
					<SubmenuEntry href="/content/main/about"><Trans>About Us</Trans></SubmenuEntry>
					<SubmenuEntry href="/contacts"><Trans>Contact Us</Trans></SubmenuEntry>
					<SubmenuEntry href="/content/main/work-with-us"><Trans>Work With Us</Trans></SubmenuEntry>
					<SubmenuEntry href="/content/main/faq"><Trans>FAQ</Trans></SubmenuEntry>
				</div>
			</Accordion>
			<Accordion open={true}>
				<MenuButton><Trans>Products</Trans></MenuButton>
				<div>
					<SubmenuEntry href="/content/products/casino"><Trans>Casino</Trans></SubmenuEntry>
					<SubmenuEntry href="/content/products/sportsbook"><Trans>Sportsbook</Trans></SubmenuEntry>
				</div>
			</Accordion>
			<Accordion open={true}>
				<MenuButton><Trans>Terms and Regulations</Trans></MenuButton>
				<div>
					<SubmenuEntry href="/content/terms/privacy"><Trans>Privacy Policy</Trans></SubmenuEntry>
					<SubmenuEntry href="/content/main/responsible-gaming"><Trans>Responsible Gaming</Trans></SubmenuEntry>
					<SubmenuEntry href="/content/terms/sport-rules"><Trans>Sport Betting Rules</Trans></SubmenuEntry>
					<SubmenuEntry href="/content/terms/conditions"><Trans>Terms & Conditions</Trans></SubmenuEntry>
				</div>
			</Accordion>
		</nav>
		<div class="bg-harif-800 text-slate-50 grow min-w-0">
			<Router>
				<PathBasedCMSText path="/content/main/about" />
				<PathBasedCMSText path="/contacts" />
				<PathBasedCMSText path="/content/main/work-with-us" />
				<PathBasedCMSText path="/content/main/faq" />
				<PathBasedCMSText path="/content/products/casino" />
				<PathBasedCMSText path="/content/products/sportsbook" />
				<PathBasedCMSText path="/content/terms/privacy" />
				<PathBasedCMSText path="/content/main/responsible-gaming" />
				<PathBasedCMSText path="/content/terms/sport-rules" />
				<PathBasedCMSText path="/content/terms/conditions" />
			</Router>
		</div>
	</div>
}

export function PromoBody() {
	return <div class="flex max-w-7xl mx-auto min-h-[inherit]">
		<nav class="hidden md:block max-w-xs w-full bg-harif-900 text-slate-50 shrink-0">
			<Accordion open={true}>
				<MenuButton><Trans>Main</Trans></MenuButton>
			<div>
				<SubmenuEntry href="/promo/cash-back"><Trans>Cashback Bonus</Trans></SubmenuEntry>
				<SubmenuEntry href="/promo/bets-bonus"><Trans>Accumulator Bonus 1000%</Trans></SubmenuEntry>
				<SubmenuEntry href="/promo/live-casout"><Trans>Live Cashout</Trans></SubmenuEntry>
				<SubmenuEntry href="/promo/weekly-cashback"><Trans>Weekly sportsbook 10% cash back</Trans></SubmenuEntry>
				<SubmenuEntry href="/promo/daily-cashback"><Trans>Daily Virtual & Casino Cashback</Trans></SubmenuEntry>
				<SubmenuEntry href="/promo/first-deposit-bonus"><Trans>500% First Deposit Bonus</Trans></SubmenuEntry>
			</div>
			</Accordion>
		</nav>
		<div class="bg-harif-800 text-slate-50 grow min-w-0">
			<Router>
				<PromosList default={true} />

				<PathBasedCMSText path="/promo/cash-back" />
				<PathBasedCMSText path="/promo/bets-bonus" />
				<PathBasedCMSText path="/promo/live-casout" />
				<PathBasedCMSText path="/promo/weekly-cashback" />
				<PathBasedCMSText path="/promo/daily-cashback" />
				<PathBasedCMSText path="/promo/first-deposit-bonus" />
			</Router>
		</div>
	</div>
}

function Accordion({ open: initialOpen, children }) {
	const [open, setOpen] = useState(!!initialOpen);
	return <Fragment>
		<div onClick={() => setOpen(!open)}>{children[0]}</div>
		{open ? children[1] : null}
	</Fragment>
}

function MenuButton({ children }) {
	return <div class="h-8 bg-harif-900 text-white border-b border-harif-950 pl-4 flex items-center text-sm">{children}</div>
}

function SubmenuEntry({ children, href }) {
	return <a class="h-8 bg-harif-800 text-white border-b border-harif-950 pl-8 flex items-center text-sm hover:bg-harif-950" href={href}>{children}</a>
}

function PathBasedCMSText({ path }) {
	return <CMSText path={path} key={path} />
}

export function CMSText({ path }) {
	const api = useHeadlessComponent(AwrabetCMSText, { path });
	const { state } = api;

	if (state.loading)
		return <div class="pt-6 text-3xl text-slate-300 text-center"></div>
	if (!state.content)
		return <div class="pt-6 text-3xl text-slate-300 text-center">
			<Trans>Page not found</Trans>
		</div>
	return <div class="pt-3 text-base px-4 prose prose-invert lg:prose-xl max-w-full">
		<Markdown markdown={state.content} />
	</div>
}

function PromosList() {
	return <div class="pt-4">
		<div class="p-6 flex flex-col md:grid md:grid-cols-2 gap-6">

			<div class="rounded shadow-xl flex relative bg-harif-800 text-slate-50">
				<div class="aspect-square h-48">
					<div class="w-full h-full relative -top-3 -left-3 rounded shadow bg-black bg-[url(../img/harif-promo/gojjo-refund.jpg)] bg-contain bg-no-repeat bg-center"></div>
				</div>
				<div class="grow pt-4 pb-2 justify-between px-2 text-xl font-light">
					<div>Cashback Bonus</div>
				</div>
				<a class="bg-custom-orange text-black w-36 rounded absolute right-2 bottom-3 text-center py-1" href="/promo/cash-back">Read More</a>
			</div>

			<div class="rounded shadow-xl flex relative bg-harif-800 text-slate-50">
				<div class="aspect-square h-48">
					<div class="w-full h-full relative -top-3 -left-3 rounded shadow bg-black bg-[url(../img/harif-promo/gojjo-acc.jpg)] bg-contain bg-no-repeat bg-center"></div>
				</div>
				<div class="grow pt-4 pb-2 justify-between px-2 text-xl font-light">
					<div>ACCUMULATOR BONUS WIN UP TO 500%</div>
				</div>
				<a class="bg-custom-orange text-black w-36 rounded absolute right-2 bottom-3 text-center py-1" href="/promo/bets-bonus">Read More</a>
			</div>

			<div class="rounded shadow-xl flex relative bg-harif-800 text-slate-50">
				<div class="aspect-square h-48">
					<div class="w-full h-full relative -top-3 -left-3 rounded shadow bg-black bg-[url(../img/harif-promo/gojjo-acc.jpg)] bg-contain bg-no-repeat bg-center"></div>
				</div>
				<div class="grow pt-4 pb-2 justify-between px-2 text-xl font-light">
					<div>Live Cashout</div>
				</div>
				<a class="bg-custom-orange text-black w-36 rounded absolute right-2 bottom-3 text-center py-1" href="/promo/live-casout">Read More</a>
			</div>

			<div class="rounded shadow-xl flex relative bg-harif-800 text-slate-50">
				<div class="aspect-square h-48">
					<div class="w-full h-full relative -top-3 -left-3 rounded shadow bg-black bg-[url(../img/harif-promo/gojjo-weekly.jpg)] bg-contain bg-no-repeat bg-center"></div>
				</div>
				<div class="grow pt-4 pb-2 justify-between px-2 text-xl font-light">
					<div>Weekly sportsbook 10% cash back</div>
				</div>
				<a class="bg-custom-orange text-black w-36 rounded absolute right-2 bottom-3 text-center py-1" href="/promo/weekly-cashback">Read More</a>
			</div>

			<div class="rounded shadow-xl flex relative bg-harif-800 text-slate-50">
				<div class="aspect-square h-48">
					<div class="w-full h-full relative -top-3 -left-3 rounded shadow bg-black bg-[url(../img/harif-promo/gojjo-daily-casino.jpg)] bg-contain bg-no-repeat bg-center"></div>
				</div>
				<div class="grow pt-4 pb-2 justify-between px-2 text-xl font-light">
					<div>Daily Virtual & Casino Cashback</div>
				</div>
				<a class="bg-custom-orange text-black w-36 rounded absolute right-2 bottom-3 text-center py-1" href="/promo/daily-cashback">Read More</a>
			</div>

			<div class="rounded shadow-xl flex relative bg-harif-800 text-slate-50">
				<div class="aspect-square h-48">
					<div class="w-full h-full relative -top-3 -left-3 rounded shadow bg-black bg-[url(../img/harif-promo/gojjo-500.jpg)] bg-contain bg-no-repeat bg-center"></div>
				</div>
				<div class="grow pt-4 pb-2 justify-between px-2 text-xl font-light">
					<div>500% First Deposit Bonus</div>
				</div>
				<a class="bg-custom-orange text-black w-36 rounded absolute right-2 bottom-3 text-center py-1" href="/promo/first-deposit-bonus">Read More</a>
			</div>

		</div>
	</div>
}
